import { Component, Input, QueryList, Renderer2, ViewChildren } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IconHover } from '../../../../enum/common-enum';
import { AgGridI } from '../../../ag-grid/ag-grid.model';
import { AgGridJournalVouchers } from './journal-vouchers-popup.model';
import { JournalVouchersPopupService } from './journal-vouchers-popup.service';
import { FileReaderService } from '../../../../services/file.reader.service';
import { CommonService } from '../../../../services/common.service';
import { DatePipe } from '@angular/common';
import { CommonFilterService } from '../../../../services/common-filter.service';
import { AgGridComponent } from '../../../ag-grid/ag-grid.component';

@Component({
  selector: 'app-journal-vouchers-popup',
  templateUrl: './journal-vouchers-popup.component.html',
  styleUrls: ['./journal-vouchers-popup.component.scss'],
  providers: [DatePipe]
})
export class JournalVouchersPopupComponent extends CommonService {
  @Input() data: any;
  currentHoverEffect = IconHover.Pink;
  agGridJournalVouchers: AgGridI;
  gridApi: any;
  apiRequestModel: any = {};
  invoiceDate : any;
  @ViewChildren(AgGridComponent) grids: QueryList<AgGridComponent>;
  constructor(
    public activeModal: NgbActiveModal,
    public journalVouchersPopupService: JournalVouchersPopupService,
    public fileReaderService: FileReaderService,
    public renderer: Renderer2,
    public datePipe: DatePipe,
    public commonFilterService: CommonFilterService,
  ) { super(renderer) }

  ngOnInit() {
    this.agGridJournalVouchers = AgGridJournalVouchers;
  }
  onGridReady(event) {
    this.gridApi = event;
    this.GetJournalVoucherDetailsByInvoice();
  }

  GetJournalVoucherDetailsByInvoice(){
    this.showLoading(this.gridApi);
    const { id, voucherTypeId, invoiceNo } = this.data?.formModel?.invoiceModel ?? this.data?.formModel ?? {};
    Object.assign(this.apiRequestModel, { id, voucherTypeId, invoiceNo });
    this.journalVouchersPopupService.journalvoucherdetailsbyinvoice(this.apiRequestModel).subscribe({
      next: (res) => {
        this.commonFilterService.processServersideApiResponse(res, this.grids.first, this.gridApi, undefined, this.apiRequestModel.getAll);
        this.invoiceDate = this.datePipe.transform(res?.response?.invoiceDate, 'dd/MM/yyyy');
      },
      error: (err) => {
          this.hideLoading(this.gridApi);          
          this.gridApi?.api?.setRowData([]);
      }
    })
  }


  callApiForExport(event) {
    const exportAs = this.apiRequestModel.exportAs;
    this.journalVouchersPopupService.journalvoucherdetailsbyinvoice(this.apiRequestModel).subscribe(
      {
        next: (res) => {
          this.fileReaderService.exportFile(res, exportAs);
        }, error(error) {
          console.error('Error in downloading Excel/Pdf file:', error);
        },
      }
    );
  }
}

